import { REMOVE_COOKIE } from "../types/removeCookies";
export const removeCookie = (payload) => ({
    type: REMOVE_COOKIE,
    payload
})